const payPathPattern = /^\/pay\/[^/]+$/;

// 支払い画面の有効時間。これを過ぎて復元された画面は失効させる
export const PAY_SCREEN_MAX_AGE_MS = 5 * 60 * 1000;

type ShouldRedirectOnPageShowParams = {
  pathname: string;
  persisted: boolean;
  navigationType?: PerformanceNavigationTiming["type"];
};

export function isPayPathname(pathname: string) {
  return payPathPattern.test(pathname);
}

type IsPayScreenStaleParams = {
  issuedAt?: number;
  now: number;
  maxAgeMs?: number;
};

export function isMissingPayScreenIssuedAt(issuedAt?: number) {
  return issuedAt === undefined || !Number.isFinite(issuedAt);
}

// navigationType では判別できない「フレッシュロードによる古いURL復元」を発行時刻で検知する
export function isPayScreenStale({
  issuedAt,
  now,
  maxAgeMs = PAY_SCREEN_MAX_AGE_MS,
}: IsPayScreenStaleParams) {
  // 欠落時は loader 側で現在時刻を付与して再遷移する。ここへ来た場合は安全側に倒す
  if (isMissingPayScreenIssuedAt(issuedAt)) {
    return true;
  }
  return now - issuedAt >= maxAgeMs;
}

export function shouldRedirectPayOnPageShow({
  pathname,
  persisted,
  navigationType,
}: ShouldRedirectOnPageShowParams) {
  if (!isPayPathname(pathname)) {
    return false;
  }

  return persisted || navigationType === "back_forward";
}
